<template>
    <div v-if="show" class="loading">
        <img src="./loading.gif" class="img_loading">
    </div>
</template>
<script>
  export default {
    name: "loading",
    data() {
      return {
        show: false
      }
    }
  }
</script>
<style scoped>
.img_loading{
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -130px 0 0 -120px;
    width: 240px;
    height: 260px;
}
.loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
}
</style>


// WEBPACK FOOTER //
// src/assets/csui/components/loading/loading.vue